<template>
    <div :class="[ size ? 'app-radio--' + size : '', useSegmentControl ? 'segment-control': 'default-radio']"
         class="app-radio">
        <label 
            :class="{
                'is-disabled': disabled,
                'is-checked': model === label,
                'is-focus': focus
            }"
            class="app-radio__label">
            <input
                :value="label"
                :name="name"
                :disabled="disabled"
                v-model="model"
                type="radio"
                class="app-radio__input"
                @change="handleChange"
                @focus="focus = true"
                @blur="focus = false">
            <span v-if="$slots.default" class="app-radio__input__inner"><slot/></span>
        </label>
    </div>
</template>

<script>
import emitter from '../../utilities/emitter'

export default {
    name: 'app-radio',
    mixins: [emitter],
    props: {
        label: {},
        disabled: Boolean,
        name: String,
        border: Boolean,
        size: String,
        useSegmentControl: Boolean
    },
    data () {
        return {
            focus: false
        }
    },
    computed: {
        value: {
            get() {
                return this.$parent.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        parentName() {
            return this.$parent ? this.$parent.$options.name : null
        },
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        handleChange() {
            this.$nextTick(() => {
                this.dispatch('app-radio-group', 'handleChange', this.value);
            });
        }
    }
}
</script>

<style lang="stylus">
@import "../../stylus/variables"

.default-radio.app-radio
    margin-right: 3px
    white-space: nowrap
    color: #606266
    font-weight: 500
    font-size: 14px
    cursor: pointer
    display: inline-block
    position: relative
    .app-radio__input
        -webkit-appearance: radio
        display: inline-block
        position absolute
        top: 9px
        left: 13px
    .app-radio__label
        padding: 9px 12px 9px 13px
        border-radius: 6px
        border: 1px solid #dcdfe6
        -webkit-box-sizing: border-box
        box-sizing: border-box
        line-height: normal
        height: 40px
        cursor: pointer
        position: relative
        -webkit-transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46)
        transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46)
        &.is-checked
            border-color: #1383ff
    .app-radio__input__inner
        padding-left: 20px

.segment-control.app-radio
    display: inline-block
    line-height: 1
    white-space: nowrap
    cursor: pointer
    background: transparent
    color: $dark-blue
    -webkit-appearance: none
    text-align: center
    box-sizing: border-box
    margin: 0
    transition: .1s
    font-weight: 500
    font-size: 13px
    flex-grow: 1
    .app-radio__label
        border: 1px solid transparent
        padding: 10px 20px
        display: block
        border-radius: 19px
        position: relative
        cursor: pointer
        transition: all .1s ease-in
        &.is-checked
            background: $dark-blue
            border-color: $dark-blue
            color: $white
        &:hover:not(.is-checked)
            background: alpha($dark-blue, 0.10)
        input[type=radio]
            position: absolute
            left: -1px
            right: -1px
            opacity: 0
        &.is-focus
            border-color: $dark-blue
    &.app-radio--small
        .app-radio__label
            padding: 8px 14px
            border-radius: 15px
            font-size: 12px
    &.app-radio--tight
        .app-radio__label
            padding: 10px
            font-size: 13px
.notification-toggles
    .default-radio.app-radio
        .app-radio__input
            top: 9px
</style>
